
import "./styles/base.css";
import "./styles/auth.css";
import "./styles/viewer.css";
import "./styles/poster.css";
import "./styles/events.css";

import RetroEventPage from "./pages/RetroEventPage";

export default function App() {
  return <RetroEventPage />;
}
